<template>
  <div class="dropdown h-100">
    <div
      id="dropdownTeam1"
      aria-expanded="false"
      class="d-block text-decoration-none dropdown-toggle position-relative w-100"
      data-bs-toggle="dropdown"
    >
      <img :src="$page.props.currentTeam.data.attributes.emblem_path" style="max-width: 2rem; max-height: 2rem; margin-top:-0.75rem" />
    </div>
    <ul aria-labelledby="dropdownTeam1" class="dropdown-menu dropdown-menu-end shadow">
      <li><span class="dropdown-item">Team wechseln</span></li>
      <template v-for="(team, id) in $page.props.user.teams" :key="id">
        <li v-if="id != $page.props.currentTeam.data.id" class="d-flex">
          <a :href="'#'" class="dropdown-item d-inline w-auto flex-grow-1">
            {{ team.name }}
          </a>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { router } from '@inertiajs/vue3';
import { ref } from 'vue';
import SkinSelect from './SkinSelect';
import StructureSelect from './StructureSelect';

export default {
  components: { StructureSelect, SkinSelect },
  props: {},
  setup() {
    const menuIsOpen = ref(true);

    const toggleMenuOpen = () => {
      menuIsOpen.value = !menuIsOpen.value;
    };

    return {
      menuIsOpen,
      toggleMenuOpen,
    };
  },
};
</script>
